<div class="store-hours-container p-3">
	<!-- Button Toggle Group for Navigation -->
	<mat-button-toggle-group
		name="storeHoursSection"
		aria-label="Store Hours Section"
		class="mb-3"
		hideSingleSelectionIndicator="true"
	>
		<mat-button-toggle
			value="operation"
			(click)="setActiveSection('operation')"
			[checked]="activeSection === 'operation'"
		>
			Operation Hours
		</mat-button-toggle>
		<mat-button-toggle
			value="special"
			(click)="setActiveSection('special')"
			[checked]="activeSection === 'special'"
		>
			Special Hours
		</mat-button-toggle>
		<mat-button-toggle
			value="preparation"
			(click)="setActiveSection('preparation')"
			[checked]="activeSection === 'preparation'"
		>
			Preparation Time
		</mat-button-toggle>
	</mat-button-toggle-group>

	<!-- Operation Hours Section -->
	<div *ngIf="activeSection === 'operation'">
		<div class="flex justify-content-between">
			<div class="special-hrs text-color">Operation Hours</div>
			<button mat-flat-button color="primary" (click)="showModal()">
				Add Operation Hours
				<mat-icon matPrefix>add</mat-icon>
			</button>
		</div>
		<div class="flex gap-2 textcontent">
			<img src="/XpressApp/assets/images/tabs_warning.png" />
			<div>
				<p>
					Set your menu availability with ease using the timeline. Select the
					desired days and adjust blocks on the graph to set start and end
					times. Your changes are saved instantly, ensuring accurate
					availability information. Learn more.
				</p>
			</div>
		</div>
		<!-- Display multiple operating hours entries -->
		<div
			*ngFor="let entry of savedOperationHours; let i = index"
			class="picked-time-layout ml-2 mt-2 mb-1"
		>
			<div class="flex justify-content-between flex-wrap w-full">
				<div class="picked-time-header">
					{{ entry.selectedDays.join(", ") }}
				</div>
				<div class="flex gap-2">
					<button mat-button color="primary" (click)="editOperationHours(i)">
						<mat-icon matPrefix>edit</mat-icon>
						Edit
					</button>
					<button
						mat-button
						color="warn"
						(click)="removeOperationHours(i)"
						*ngIf="savedOperationHours.length > 1"
					>
						<mat-icon matPrefix>delete</mat-icon>
						Remove
					</button>
				</div>
			</div>
			<div class="pick-time-sub-header">Operating Days</div>

			<div class="picked-time-header">
				<div
					*ngFor="let timeRange of entry.timeRanges; let j = index"
					class="time-range-display"
				>
					{{ formatTime(timeRange.hour, timeRange.minute, timeRange.period) }} -
					{{
						formatTime(
							timeRange.endHour,
							timeRange.endMinute,
							timeRange.endPeriod
						)
					}}
				</div>
			</div>
			<div class="pick-time-sub-header">Store Hours</div>
		</div>

		<!-- Show empty state when no operation hours are set -->
		<div
			*ngIf="savedOperationHours.length === 0"
			class="flex align-items-center justify-content-center operationlogo"
		>
			<img src="/XpressApp/assets/images/nooperationhrs.png" />
		</div>
	</div>

	<!-- Special Hours Section -->
	<div *ngIf="activeSection === 'special'">
		<div class="flex justify-content-between">
			<div class="special-hrs text-color">Special Hours</div>
			<button
				mat-flat-button
				color="primary"
				(click)="openAddSpecialHoursDialog()"
			>
				Add Special Hours
				<mat-icon matPrefix>add</mat-icon>
			</button>
		</div>
		<div class="flex gap-2 textcontent">
			<img src="/XpressApp/assets/images/tabs_warning.png" />
			<div>
				<p>
					Set your menu availability with ease using the timeline. Select the
					desired days and adjust blocks on the graph to set start and end
					times. Your changes are saved instantly, ensuring accurate
					availability information. Learn more.
				</p>
			</div>
		</div>

		<!-- Display special hours entries -->
		<div
			*ngFor="let specialHour of saveSpecialHours; let i = index"
			class="picked-time-layout ml-2 mt-2 mb-1"
		>
			<div class="flex justify-content-between flex-wrap w-full">
				<div class="picked-time-header">
					{{
						formatSpecialHoursDateRange(
							specialHour.startDate,
							specialHour.endDate
						)
					}}
				</div>
				<div class="flex gap-2">
					<button mat-button color="primary" (click)="editSpecialHours(i)">
						<mat-icon matPrefix>edit</mat-icon>
						Edit
					</button>
					<button mat-button color="warn" (click)="removeSpecialHours(i)">
						<mat-icon matPrefix>delete</mat-icon>
						Remove
					</button>
				</div>
			</div>
			<div class="pick-time-sub-header">Date Range</div>

			<div
				class="picked-time-header"
				*ngIf="specialHour.availability && !specialHour.open24hrs"
			>
				<div
					*ngFor="let timeRange of specialHour.timeRanges; let j = index"
					class="time-range-display"
				>
					{{ formatTime(timeRange.hour, timeRange.minute, timeRange.period) }} -
					{{
						formatTime(
							timeRange.endHour,
							timeRange.endMinute,
							timeRange.endPeriod
						)
					}}
				</div>
			</div>
			<div class="picked-time-header" *ngIf="specialHour.open24hrs">
				<div class="time-range-display">Open 24 Hours</div>
			</div>
			<div class="picked-time-header" *ngIf="!specialHour.availability">
				<div class="time-range-display">Closed</div>
			</div>
			<div class="pick-time-sub-header">Special Hours</div>

			<div class="picked-time-header" *ngIf="specialHour.description">
				<div class="time-range-display">{{ specialHour.description }}</div>
			</div>
			<div class="pick-time-sub-header" *ngIf="specialHour.description">
				Description
			</div>
		</div>

		<!-- Show empty state when no special hours are set -->
		<div
			*ngIf="saveSpecialHours.length === 0"
			class="operationlogo flex flex-column align-items-center justify-content-center gap-2"
		>
			<img src="/XpressApp/assets/images/noOperation.png" />
            <div class="flex flex-column align-items-center">
                <h5 class="text-center">No Special Hours Set</h5>
                <p class="textbanner text-center">There's nothing here yet. Add specific dates and times for holidays or temporary changes to your regular delivery schedule.</p>
            </div>
		</div>
	</div>

	<!-- Preparation Time Section -->
	<div *ngIf="activeSection === 'preparation'">
		<div class="prep-time-title">Preparation Time</div>
		<div class="prep-time-card">
			<div
				class="flex justify-content-between flex-wrap w-full align-items-center"
			>
				<div class="prep-time-value">{{ prepTimeValue }}</div>
				<button mat-button color="primary" (click)="onEditPreparationTime()">
					<mat-icon matPrefix>edit</mat-icon>
					Edit
				</button>
			</div>
			<div class="prep-time-sub">Preparation Time</div>
		</div>
	</div>
</div>
